import React from "react";
import Login from '../modules/Authentication/Login';
import Logout from '../modules/Authentication/Logout';
import ForgetPasswordPage from '../modules/Authentication/ForgetPassword';
import ResetPassword from '../modules/Authentication/ResetPassword';
import User from '../modules/user/User';
import Ticket from '../modules/ticket/ticket';
import Lead from '../modules/Lead/lead';
import Course from "../modules/Course/course";
import Tips from "modules/Tips/Tips";
import Insurance from "modules/Insurance/Insurance";
import InsuranceCustomer from "modules/Insurance/Customer/customer";
import Faq from "modules/Faq/faq";
import Categories from "modules/Categories/categories";
import PaymentGateway from "modules/PaymentGateway/paymentgateway";

import { Link } from "react-router-dom";  // ← ADD THIS
import TicketFeedbackSummary from "modules/TicketFeedback/ticketfeedback";
import Delivery from "modules/Delivery/delivery";
import Deliverycharge from "modules/Deliverycharge/deliverycharge";
import TicketCategory from "modules/TicketCategory/ticketcategory";
import GoalCategory from "modules/Goal/goalcategory";
import GoalSubCategory from "modules/Goal/goalsubcategory";
import UserType from "modules/RBAC/usertype/usertype";
import RoleMaster from "modules/RBAC/rolemaster/rolemaster";
import PermissionPage from "modules/RBAC/permissionmaster/permissionpage";
import RolePermissionPage from "modules/RBAC/rolepermissionmaster/rolepermissionpage";
import UserMasterPage from "modules/RBAC/usermaster/usermaster";
import UserRolePage from "modules/RBAC/userrole/userrole";
import ApplicationPage from "modules/RBAC/applicationmaster/application";
import ModuleMasterPage from "modules/RBAC/modulemaster/modulemaster";
import MenuMasterPage from "modules/RBAC/menumaster/menumaster";
import TaskMasterPage from "modules/RBAC/taskmaster/taskmaster";
import RoleTaskMasterPage from "modules/RBAC/roletaskmaster/roletaskmaster";
import MenuPermissionMasterPage from "modules/RBAC/menupermissionmaster/menupermission";
import RoleMenuMasterPage from "modules/RBAC/rolemenu/rolemenu";
import TransactionPage from "modules/Report/Transactions/transaction";
import FamilyDetailPage from "modules/Report/Goals/familydetail";
import FamilyGoalsPage from "modules/Report/Goals/familygoals";
import ProposalPolicyForm from "modules/KYC/personal_details";
import BulkUpload from "modules/BulkUpload/BulkUpload";
// import UserProfile from '../modules/Authentication/user-profile';

// Lazy load main application modules
const Dashboard = React.lazy(() => import('../modules/Dashboard/admins'));
// const User = React.lazy(() => import('../modules/user/User'));


type AppRoute = {
  path: string;
  component: JSX.Element;
  constant: string;
};

const authProtectedRoutes: AppRoute[] = [
  { path: '/dashboard', component: <Dashboard />, constant: 'dashboard' },
  { path: "/user", component: <User/>, constant: 'users' },
  { path: "/ticket", component: <Ticket/>, constant: 'ticket' },
  { path: "/ticketcategory", component: <TicketCategory/>, constant: 'ticketcategory' },
  { path: "/lead", component: <Lead/>, constant: 'lead' },
  { path: "/course", component: <Course/>, constant: 'course' },
  { path: "/tips", component: <Tips/>, constant: 'tips' },
  { path: "/insurance", component: <Insurance/>, constant: 'insurance' },
  { path: "/insurance/customers", component: <InsuranceCustomer />, constant: 'insurancecustomers' },
  { path: "/kyc/personal-details", component: <ProposalPolicyForm/>, constant: 'kyc' },
  { path: "/faq", component:<Faq/>, constant: 'faq'},
  { path: "/doorstepdelivery", component:<Delivery/>, constant: 'doorstepdelivery'},
  { path: "/deliverycharge", component:<Deliverycharge/>, constant: 'deliverycharge'},
  { path: "/deliverycharges", component:<Deliverycharge/>, constant: 'deliverycharge'},
  { path: "/categories", component:<Categories/>, constant: 'categories'},
  { path: "/ticketfeedback", component:<TicketFeedbackSummary/>, constant: 'ticketfeedback'},
  { path: "/goalcategory", component:<GoalCategory/>, constant: 'goalcategory'}, 
  { path: "/goalsubcategory", component:<GoalSubCategory/>, constant: 'goalsubcategory'}, 
  { path: "/usertype", component:<UserType/>, constant: 'usertype'}, 
  { path: "/rolemaster", component:<RoleMaster/>, constant: 'rolemaster'}, 
  { path: "/permissionmaster", component:<PermissionPage/>, constant: 'permissionmaster'}, 
  { path: "/rolepermissionmaster", component:<RolePermissionPage/>, constant: 'rolepermissionmaster'}, 
  { path: "/usermaster", component:<UserMasterPage/>, constant: 'usermaster'}, 
  { path: "/userrolemaster", component:<UserRolePage/>, constant: 'userrolemaster'},
  { path: "/applicationmaster", component:<ApplicationPage/>, constant: 'applicationmaster'},
  { path: "/modulemaster", component:<ModuleMasterPage/>, constant: 'modulemaster'},
  { path: "/menumaster", component:<MenuMasterPage/>, constant: 'menumaster'},
  { path: "/taskmaster", component:<TaskMasterPage/>, constant: 'taskmaster'},
  { path: "/roletaskmaster", component:<RoleTaskMasterPage/>, constant: 'roletaskmaster'},
  { path: "/menupermissionmaster", component:<MenuPermissionMasterPage/>, constant: 'menupermissionmaster'},
  { path: "/rolemenumaster", component:<RoleMenuMasterPage/>, constant: 'rolemenumaster'},
  { path: "/transactionreport", component:<TransactionPage/>, constant: 'transactionreport'},
  { path: "/goalreport", component:<FamilyDetailPage/>, constant: 'goalreport'},
  { path: "/familygoals", component:<FamilyGoalsPage/>, constant: 'familygoals'},
  { path: "/bulkupload", component: <BulkUpload />, constant: 'bulkupload' },
  { path: '*', component: <Dashboard />, constant: '*' }
  // to be updated later
  // { path: '/profile', component: <UserProfile />, constant: 'profile' }, 
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/paymentgateway", component:<PaymentGateway/>, constant: 'paymentgateway'},
];

export { authProtectedRoutes, publicRoutes };
